export default [
    '/user/login',
    '/user/forgot-password',
    '/user/reset-password'   
]